import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PublicHeader from '../components/Header/PublicHeader';
import PublicFooter from '../components/Footer/PublicFooter';
import Button from '../components/ui/Button';
import './PendingApproval.css';

const PendingApproval = () => {
  const { user, refreshProfile, logout } = useAuth();
  const [checking, setChecking] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleCheckStatus = async () => {
    setChecking(true);
    setMessage('');
    try {
      const data = await refreshProfile();
      if (data && (data.role === 'ADMIN' || data.role === 'MANAGER' || data.role === 'USER')) {
        navigate('/dashboard');
      } else {
        setMessage('Your account is still pending administrator approval.');
      }
    } catch {
      setMessage('Failed to refresh status. Please try again in a few moments.');
    } finally {
      setChecking(false);
    }
  };

  return (
    <>
      <PublicHeader />
      <section className="status-page-wrapper">
        <div className="status-card">
          <div className="status-icon pending-icon">⏳</div>
          <h1 className="status-title">Approval Pending</h1>
          <p className="status-text">
            Thank you for registering with Vaultize{user?.email ? ` (${user.email})` : ''}.
            Your account is currently undergoing security clearance and organization verification.
          </p>

          {message && <div className="status-notice">{message}</div>}

          <div className="status-actions">
            <Button
              variant="primary"
              onClick={handleCheckStatus}
              disabled={checking}
            >
              {checking ? 'Checking…' : 'Check Status'}
            </Button>
            <Button
              variant="secondary"
              onClick={logout}
            >
              Sign Out
            </Button>
          </div>

          <div className="status-footer-note">
            Need urgent access? Contact{' '}
            <a href="mailto:support@vaultize.com">support@vaultize.com</a>
          </div>
        </div>
      </section>
      <PublicFooter />
    </>
  );
};

export default PendingApproval;
